<template>
    <div
        id="contacts"
        class="col-12">
        <contact-search/>
        <div class="box box-success">
            <div class="box-header">
                <h3 class="box-title">Seznam kontaktov</h3>
            </div>
            <div
                :class="isLoading ? 'loading' : ''"
                class="box-body table-responsive no-padding">
                <div class="loader">
                    <img
                        src="/images/spinner.svg"
                        alt="Nalagam"
                        width="200"
                        height="200">
                    <b>NALAGAM</b>
                </div>
                <vuetable
                    id="contacts-main-table"
                    ref="vuetable"
                    :api-url="api_route"
                    :fields="fields"
                    :css="css.table"
                    :row-class="rowClass"
                    :initial-page="initialPage"
                    :per-page="perPage"
                    :sort-order="sortOrder"
                    :multi-sort="true"
                    :append-params="moreParams"
                    pagination-path="meta"
                    detail-row-component="contact-versions"
                    @vuetable:loaded="dataLoaded"
                    @vuetable:cell-clicked="onCellClicked"
                    @vuetable:pagination-data="onPaginationData"/>
            </div>
            <div class="box-footer clearfix">
                <div class="vuetable-pagination pagination pagination-sm no-margin pull-left">
                    <p>Zadetkov na stran</p>
                    <select
                        v-model="perPage"
                        @change="changePerPage">
                        <option
                            v-for="option in perPageOptions"
                            :key="option"
                            :value="option">
                            {{ option }} / stran
                        </option>
                    </select>
                </div>
                <div class="vuetable-pagination pagination pagination-sm no-margin pull-right">
                    <vuetable-pagination-info
                        ref="paginationInfo"
                        info-template="Prikazujem {from} do {to} od {total} zapisov"
                        info-class="pagination-info"/>
                    <vuetable-pagination-dropdown
                        ref="pagination"
                        :css="css.dropdownPagination"
                        page-text="stran"
                        @vuetable-pagination:change-page="onChangePage"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Vuetable                   from 'vuetable-2/src/components/Vuetable';
import VuetablePagination         from 'vuetable-2/src/components/VuetablePagination';
import VuetablePaginationDropdown from '../VuetablePaginationDropdownWithFirstAndLast';
import VuetablePaginationInfo     from 'vuetable-2/src/components/VuetablePaginationInfo';
import TablePagination            from '../../mixins/TablePagination';
import ContactVersions            from './Components/ContactVersions';
import Table                      from '../../mixins/Table';
import TableUrlParams             from '../../mixins/TableUrlParams';
import ApiRoutes                  from '../../mixins/ApiRoutes';
import ContactsCommon             from '../../mixins/Contacts';
import ContactSearch              from './ContactSearch';
import SourceLabel                from './Components/SourceLabel';
//import ContactSubscriptions       from './Components/Subscriptions';

Vue.component('contact-versions', ContactVersions);
Vue.component('contact-source-label', SourceLabel);
//Vue.component('contact-subscriptions', ContactSubscriptions);

export default {
    name: 'Contacts',

    components: {
        Vuetable,
        VuetablePagination,
        VuetablePaginationDropdown,
        VuetablePaginationInfo,
        ContactSearch
    },

    mixins: [
        ApiRoutes,
        Table,
        TableUrlParams,
        ContactsCommon,
        TablePagination
    ],

    data() {
        return {
            fields:  [
                {
                    name:      'id',
                    title:     '#',
                    sortField: 'id',
                },
                {
                    name:      '__component:contact-source-label',
                    title:     'vir',
                    sortField: 'source'
                },
                {
                    name:      'bounced',
                    title:     'bounced',
                    callback:  value => {
                        if (value) {
                            return '<span class="label label-danger">da</span>';
                        } else {
                            return '<span class="label label-success">ne</span>';
                        }
                    },
                    sortField: 'bounced_at'
                },
                {
                    name:      'email',
                    title:     'e-pošta',
                    callback:  value => value ? value : 'n/a',
                    sortField: 'email'
                },
                {
                    name:       'mailing_lists_count',
                    title:      'št. mailingov',
                    titleClass: 'text-center',
                    dataClass:  'text-center'
                },
                {
                    name:      'phone',
                    title:     'telefon',
                    callback:  value => value ? value : 'n/a',
                    sortField: 'phone'
                },
                {
                    name:      'mobile_phone',
                    title:     'GSM',
                    callback:  value => value ? value : 'n/a',
                    sortField: 'mobile_phone'
                },
                {
                    name:      'tax_id',
                    title:     'davčna',
                    callback:  value => value ? value : 'n/a',
                    sortField: 'tax_id'
                },
                {
                    name:      'name',
                    title:     'ime',
                    callback:  value => value ? value : 'n/a',
                    sortField: 'name'
                },
                {
                    name:      'sex',
                    title:     'spol',
                    callback:  value => {
                        switch (value) {
                        case 'male':
                            return '<span class="label label-primary">moški</span>';
                        case 'female':
                            return '<span class="label label-danger">ženska</span>';
                        case 'neutral':
                        default:
                            return '<span class="label label-warning">nedoločen</span>';
                        }
                    },
                    sortField: 'sex'
                },
                {
                    name:      'birthday',
                    title:     'roj.',
                    callback:  value => this.$options.filters.formatDate(value, 'YYYY'),
                    sortField: 'birthday'
                },
                {
                    name:      'address',
                    title:     'naslov',
                    callback:  value => value ? value : 'n/a',
                    sortField: 'address'
                },
                {
                    name:      'post',
                    title:     'pošta',
                    callback:  value => value ? `${value.id} ${value.name}` : 'n/a',
                    sortField: 'post'
                },
                {
                    name:      'municipality',
                    title:     'občina',
                    callback:  value => value ? value.name : 'n/a',
                    sortField: 'municipality'
                },
                {
                    name:      'region',
                    title:     'regija',
                    callback:  value => value ? value.name : 'n/a',
                    sortField: 'region'
                },
                /* {
                    name:       '__component:contact-subscriptions',
                    title:      'mailingi',
                    titleClass: 'text-center',
                    dataClass:  'text-center status category-status'
                } */
            ],
            perPage: 12,

            css: {
                table: {
                    tableClass: 'table table-striped table-hover'
                }
            },

            filterBy: Object.keys(ContactSearch.data().search)
        };
    },

    methods: {
        onChangePage(page) {
            this.$refs.vuetable.changePage(page);

            this.dataLoading();
        },
    },

    events: Object.assign({
        search(data) {
            this.$set(this, 'moreParams', data);

            Vue.nextTick(() => this.$refs.vuetable.refresh());

            this.dataLoading();
        }
    }, Table.events)
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/Contacts/Contacts.vue